module.exports = __webpack_public_path__ + "img/icon-eyeopen.914b2ca7.svg";